import './Banner.css';
// IMPORTA a imagem como um módulo JavaScript para que o bundler possa processá-la corretamente
import bannerImage from '../../assets/imagens/index__banner.png';

const Banner=  () =>  {

    return (
            <section className="index__banner">
                <img 
                    className="index__banner--imagem"
                     src={bannerImage} alt="Banner principal do site Viver Espírita"> 
                </img>        
            </section>   
    );
}

export default Banner;